// // components/CustomDatePicker.jsx
// import React, { useState, useEffect, useRef } from 'react';
// import { format, startOfMonth, endOfMonth, eachDayOfInterval, isToday, addMonths, subMonths, addYears, subYears, startOfWeek, endOfWeek, isSameMonth } from 'date-fns';
// import { ChevronLeft, ChevronRight, ChevronsLeft, ChevronsRight, Calendar, AlertCircle} from 'lucide-react';

// const CustomDatePicker = ({
//   value,
//   onChange,
//   allOrders = {},
//   branches = [], // Add branches prop
//   showCapacityInfo = true,
//   placeholder = "dd-mm-yyyy",
//   containerClassName = "",
//   inputClassName = "",
//   calendarClassName = "",
//   buttonClassName = "",
//   iconClassName = "",
//   error = false,
// }) => {
//   const [isOpen, setIsOpen] = useState(false);
//   const [currentMonth, setCurrentMonth] = useState(new Date());
//   const [hoveredDate, setHoveredDate] = useState(null);
//   const [calendarPosition, setCalendarPosition] = useState({
//     top: 'auto',
//     bottom: 'auto',
//     left: 'auto',
//     right: 'auto',
//     transform: 'none'
//   });
//   const [capacityCardPosition, setCapacityCardPosition] = useState({ show: false, side: 'right', top: 0 });
//   const [showWarningModal, setShowWarningModal] = useState(false);
//   const [warningDate, setWarningDate] = useState(null);

//   const inputRef = useRef(null);
//   const calendarRef = useRef(null);

//   // Default classes
//   const defaultContainerClass = "relative w-full";
//   const defaultInputClass = `w-full border rounded-[7px] shadow-sm px-3 py-1.5 cursor-pointer transition-colors flex items-center justify-between ${error
//     ? 'border-red-500'
//     : (value ? "border-blue-700 text-blue-700" : "border-gray-300")
//     }`;
//   const defaultCalendarClass = "absolute mt-1 mb-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 overflow-visible";
//   const defaultButtonClass = "relative h-7 text-xs rounded transition-all";
//   const defaultIconClass = "w-4 h-4";

//   // Get branch capacity
//   const getBranchCapacity = (branchCode) => {
//     const branch = branches.find(b => b.branchCode === branchCode);
//     return branch?.branchCapacity ; // fallback to 10 if not found
//   };

//   // Calculate calendar position with viewport awareness
//   useEffect(() => {
//     if (isOpen && inputRef.current && calendarRef.current) {
//       const inputRect = inputRef.current.getBoundingClientRect();
//       const calendarWidth = 260;
//       const calendarHeight = 320;
//       const padding = 10;

//       const viewport = {
//         width: window.innerWidth,
//         height: window.innerHeight
//       };

//       let position = {
//         top: 'auto',
//         bottom: 'auto',
//         left: 'auto',
//         right: 'auto',
//         transform: 'none'
//       };

//       const spaceBelow = viewport.height - inputRect.bottom - padding;
//       const spaceAbove = inputRect.top - padding;

//       if (spaceBelow >= calendarHeight) {
//         position.top = '100%';
//       } else if (spaceAbove >= calendarHeight) {
//         position.bottom = '100%';
//       } else {
//         position.top = '100%';
//       }

//       const spaceOnRight = viewport.width - inputRect.left - padding;
//       const spaceOnLeft = inputRect.right - padding;

//       if (spaceOnRight >= calendarWidth) {
//         position.left = '0';
//       } else if (spaceOnLeft >= calendarWidth) {
//         position.right = '0';
//       } else {
//         const leftOffset = (viewport.width - calendarWidth) / 2 - inputRect.left;
//         position.left = `${leftOffset}px`;

//         if (inputRect.left + leftOffset < padding) {
//           position.left = `${padding - inputRect.left}px`;
//         } else if (inputRect.left + leftOffset + calendarWidth > viewport.width - padding) {
//           position.left = `${viewport.width - padding - calendarWidth - inputRect.left}px`;
//         }
//       }

//       setCalendarPosition(position);
//     }
//   }, [isOpen]);

//   // Reset hover state when calendar closes
//   useEffect(() => {
//     if (!isOpen) {
//       setHoveredDate(null);
//       setCapacityCardPosition({ show: false, side: 'right', top: 0 });
//     }
//   }, [isOpen]);

//   // Close calendar when clicking outside
//   useEffect(() => {
//     const handleClickOutside = (event) => {
//       if (calendarRef.current && !calendarRef.current.contains(event.target) &&
//           inputRef.current && !inputRef.current.contains(event.target)) {
//         setIsOpen(false);
//       }
//     };

//     if (isOpen) {
//       document.addEventListener('mousedown', handleClickOutside);
//     }

//     return () => document.removeEventListener('mousedown', handleClickOutside);
//   }, [isOpen]);

//   // Handle window resize
//   useEffect(() => {
//     const handleResize = () => {
//       if (isOpen) {
//         setIsOpen(false);
//         setTimeout(() => setIsOpen(true), 0);
//       }
//     };

//     window.addEventListener('resize', handleResize);
//     return () => window.removeEventListener('resize', handleResize);
//   }, [isOpen]);

//   // Get capacity info with branch-specific calculations
//   const getCapacityInfo = (date) => {
//     const dateStr = format(date, 'yyyy-MM-dd');
//     const orders = allOrders[dateStr] || [];

//     // Group orders by branch
//     const ordersByBranch = orders.reduce((acc, order) => {
//       if (!acc[order.branchCode]) {
//         acc[order.branchCode] = [];
//       }
//       acc[order.branchCode].push(order);
//       return acc;
//     }, {});

//     // Calculate capacity for each branch
//     const branchCapacities = Object.entries(ordersByBranch).map(([branchCode, branchOrders]) => {
//       const capacity = getBranchCapacity(branchCode);
//       const used = branchOrders.length;
//       const percentage = (used / capacity) * 100;

//       return {
//         branchCode,
//         capacity,
//         used,
//         remaining: capacity - used,
//         percentage
//       };
//     });

//     // Calculate overall capacity (for all branches that have orders)
//     const activeBranches = Object.keys(ordersByBranch);
//     const totalCapacity = activeBranches.length > 0
//       ? activeBranches.reduce((sum, branchCode) => sum + getBranchCapacity(branchCode), 0)
//       : branches.reduce((sum, branch) => sum + branch.branchCapacity, 0); // Use all branches if no orders

//     const totalUsed = orders.length;
//     const totalRemaining = totalCapacity - totalUsed;
//     const overallPercentage = totalCapacity > 0 ? (totalUsed / totalCapacity) * 100 : 0;

//     // Find the highest percentage among branches (for color coding)
//     const maxBranchPercentage = branchCapacities.length > 0
//       ? Math.max(...branchCapacities.map(b => b.percentage))
//       : 0;

//     return {
//       used: totalUsed,
//       remaining: totalRemaining,
//       percentage: overallPercentage,
//       maxBranchPercentage, // Use this for color coding
//       orders,
//       dateStr,
//       branchCapacities,
//       totalCapacity
//     };
//   };

//   // Get color for capacity - now using the highest branch percentage
//   const getCapacityColor = (capacityInfo) => {
//     const percentage = capacityInfo.maxBranchPercentage || capacityInfo.percentage;

//     if (percentage === 0) return 'text-gray-700';
//     if (percentage <= 50) return 'text-blue-600 bg-blue-50';
//     if (percentage < 90) return 'text-yellow-600 bg-yellow-50';
//     return 'text-red-600 bg-red-50';
//   };

//   // Handle date hover with mobile-friendly positioning
//   const handleDateHover = (date, event) => {
//     if (!showCapacityInfo) return;

//     const capacityInfo = getCapacityInfo(date);
//     if (capacityInfo.used > 0) {
//       setHoveredDate(date);

//       const buttonRect = event.target.getBoundingClientRect();
//       const calendarRect = calendarRef.current?.getBoundingClientRect();

//       if (calendarRect) {
//         const isMobile = window.innerWidth < 640;
//         const cardWidth = 200;
//         const cardHeight = 180; // Increased height for branch info

//         let side = 'right';
//         let topPosition = buttonRect.top - calendarRect.top;

//         const spaceOnRight = window.innerWidth - calendarRect.right;
//         const spaceOnLeft = calendarRect.left;

//         if (isMobile) {
//           side = 'inside';
//           topPosition = 'auto';
//         } else if (spaceOnRight < cardWidth && spaceOnLeft > cardWidth) {
//           side = 'left';
//         }

//         if (topPosition + cardHeight > calendarRect.height) {
//           topPosition = Math.max(0, topPosition - cardHeight + 30);
//         }

//         setCapacityCardPosition({
//           show: true,
//           side,
//           top: topPosition
//         });
//       }
//     }
//   };

//   // Handle date selection
//   const handleDateSelect = (date) => {
//     setHoveredDate(null);
//     setCapacityCardPosition({ show: false, side: 'right', top: 0 });

//     if (showCapacityInfo) {
//       const capacityInfo = getCapacityInfo(date);

//       // Check if any branch is at 90% or more capacity
//       const hasHighCapacityBranch = capacityInfo.branchCapacities.some(branch => branch.percentage >= 90);

//       if (hasHighCapacityBranch) {
//         setWarningDate(date);
//         setShowWarningModal(true);
//         return;
//       }
//     }

//     onChange(format(date, 'yyyy-MM-dd'));
//     setIsOpen(false);
//   };

//   // Confirm high capacity date selection
//   const confirmHighCapacityDate = () => {
//     if (warningDate) {
//       onChange(format(warningDate, 'yyyy-MM-dd'));
//       setIsOpen(false);
//       setShowWarningModal(false);
//       setWarningDate(null);
//     }
//   };

//   // Clear date
//   const handleClearDate = () => {
//     onChange('');
//     setIsOpen(false);
//   };

//   // Get all days to display
//   const getAllDaysInView = () => {
//     const start = startOfWeek(startOfMonth(currentMonth));
//     const end = endOfWeek(endOfMonth(currentMonth));
//     return eachDayOfInterval({ start, end });
//   };

//   // Navigate year
//   const goToPreviousYear = () => setCurrentMonth(subYears(currentMonth, 1));
//   const goToNextYear = () => setCurrentMonth(addYears(currentMonth, 1));

//   // Navigate month
//   const goToPreviousMonth = () => setCurrentMonth(subMonths(currentMonth, 1));
//   const goToNextMonth = () => setCurrentMonth(addMonths(currentMonth, 1));

//   // Handle input click without focus
//   const handleInputClick = (e) => {
//     e.preventDefault();
//     setIsOpen(!isOpen);
//   };

//   return (
//     <>
//       <div className={`${defaultContainerClass} ${containerClassName}`} ref={inputRef}>
//         {/* Date Input */}
//         <div
//           onClick={handleInputClick}
//           className={`${defaultInputClass} ${inputClassName}`}
//         >
//           <span>
//             {value ? format(new Date(value), 'dd-MM-yyyy') : placeholder}
//           </span>
//           <Calendar className={`${defaultIconClass} ${iconClassName}`} />
//         </div>

//         {/* Calendar Dropdown */}
//         {isOpen && (
//           <div
//             ref={calendarRef}
//             className={`${defaultCalendarClass} ${calendarClassName}`}
//             style={{
//               ...calendarPosition,
//               width: '260px',
//               maxWidth: 'calc(100vw - 20px)'
//             }}
//           >
//             {/* Compact Navigation */}
//             <div className="p-2 border-b border-gray-200">
//               <div className="flex items-center justify-between">
//                 <button
//                   onClick={goToPreviousYear}
//                   className="p-0.5 hover:bg-gray-100 rounded transition-colors"
//                   title="Previous year"
//                   type='button'
//                 >
//                   <ChevronsLeft className="w-3.5 h-3.5" />
//                 </button>

//                 <button
//                   onClick={goToPreviousMonth}
//                   className="p-0.5 hover:bg-gray-100 rounded transition-colors"
//                   title="Previous month"
//                   type='button'
//                 >
//                   <ChevronLeft className="w-3.5 h-3.5" />
//                 </button>

//                 <h3 className="text-xs font-semibold px-2">
//                   {format(currentMonth, 'MMM yyyy')}
//                 </h3>

//                 <button
//                   onClick={goToNextMonth}
//                   className="p-0.5 hover:bg-gray-100 rounded transition-colors"
//                   title="Next month"
//                   type='button'
//                 >
//                   <ChevronRight className="w-3.5 h-3.5" />
//                 </button>

//                 <button
//                   onClick={goToNextYear}
//                   className="p-0.5 hover:bg-gray-100 rounded transition-colors"
//                   title="Next year"
//                   type='button'
//                 >
//                   <ChevronsRight className="w-3.5 h-3.5" />
//                 </button>
//               </div>
//             </div>

//             {/* Compact Calendar Grid */}
//             <div className="p-2">
//               {/* Weekday headers */}
//               <div className="grid grid-cols-7 gap-0.5 mb-0.5">
//                 {['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'].map(day => (
//                   <div key={day} className="text-center text-xs text-gray-500 font-medium py-0.5">
//                     {day}
//                   </div>
//                 ))}
//               </div>

//               {/* Days Grid */}
//               <div className="grid grid-cols-7 gap-0.5">
//                 {getAllDaysInView().map((date, index) => {
//                   const isCurrentMonth = isSameMonth(date, currentMonth);
//                   const capacityInfo = getCapacityInfo(date);
//                   const isSelected = value && format(date, 'yyyy-MM-dd') === value;
//                   const colorClass = getCapacityColor(capacityInfo);

//                   const dateButtonClass = `
//                     ${defaultButtonClass} ${buttonClassName}
//                     ${!isCurrentMonth ? 'text-gray-400' : 'text-gray-700'}
//                     ${isSelected ? 'bg-blue-600 text-white hover:bg-blue-700' : 'hover:bg-gray-100'}
//                     ${isToday(date) && !isSelected ? 'font-bold ring-1 ring-blue-400' : ''}
//                     ${!isSelected && isCurrentMonth && capacityInfo.used > 0 && showCapacityInfo ? colorClass : ''}
//                   `.trim();

//                   return (
//                     <button
//                       type='button'
//                       key={index}
//                       onClick={() => handleDateSelect(date)}
//                       onMouseEnter={(e) => handleDateHover(date, e)}
//                       onMouseLeave={() => {
//                         setHoveredDate(null);
//                         setCapacityCardPosition({ ...capacityCardPosition, show: false });
//                       }}
//                       className={dateButtonClass}
//                     >
//                       <span>{format(date, 'd')}</span>
//                       {showCapacityInfo && capacityInfo.used > 0 && !isSelected && (
//                         <div className={`absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full
//                           ${capacityInfo.maxBranchPercentage <= 50 ? 'bg-blue-500' : ''}
//                           ${capacityInfo.maxBranchPercentage > 50 && capacityInfo.maxBranchPercentage < 90 ? 'bg-yellow-500' : ''}
//                           ${capacityInfo.maxBranchPercentage >= 90 ? 'bg-red-500' : ''}
//                         `} />
//                       )}
//                     </button>
//                   );
//                 })}
//               </div>

//               {/* Clear and Today buttons */}
//               <div className="mt-2 pt-2 border-t border-gray-200 flex justify-between">
//                 <button
//                   type='button'
//                   onClick={handleClearDate}
//                   className="text-xs text-gray-600 hover:text-gray-700 font-medium
//                            py-0.5 px-2 hover:bg-gray-50 rounded transition-colors"
//                 >
//                   Clear
//                 </button>
//                 <button
//                   type='button'
//                   onClick={() => {
//                     const today = new Date();
//                     setCurrentMonth(today);
//                     handleDateSelect(today);
//                   }}
//                   className="text-xs text-blue-600 hover:text-blue-700 font-medium
//                            py-0.5 px-2 hover:bg-blue-50 rounded transition-colors"
//                 >
//                   Today
//                 </button>
//               </div>
//             </div>

//             {/* Enhanced Capacity Info Card */}
//             {showCapacityInfo && hoveredDate && capacityCardPosition.show && (
//               <div
//                 className={`
//                   ${capacityCardPosition.side === 'inside' ?
//                     'absolute bottom-0 left-0 right-0 border-t' :
//                     `absolute ${capacityCardPosition.side === 'right' ? 'left-full ml-1' : 'right-full mr-1'}`
//                   }
//                   bg-white border border-gray-200 rounded-md shadow-lg p-2 z-[60] min-w-[180px]
//                 `}
//                 style={capacityCardPosition.side !== 'inside' ? { top: `${capacityCardPosition.top}px` } : {}}
//               >
//                 <div className="text-xs">
//                   <div className="font-semibold text-gray-800 mb-1">
//                     {format(hoveredDate, 'dd MMM yyyy')}
//                   </div>

//                   {/* Overall capacity */}
//                   <div className="space-y-0.5 pb-1 mb-1 border-b border-gray-200">
//                     <div className="flex justify-between">
//                       <span className="text-gray-600">Total Orders:</span>
//                       <span className="font-medium">
//                         {getCapacityInfo(hoveredDate).used}
//                       </span>
//                     </div>
//                   </div>

//                   {/* Branch-wise capacity */}
//                   {getCapacityInfo(hoveredDate).branchCapacities.length > 0 && (
//                     <div className="space-y-1">
//                       <div className="text-xs font-medium text-gray-700">By Branch:</div>
//                       {getCapacityInfo(hoveredDate).branchCapacities.map((branch) => (
//                         <div key={branch.branchCode} className="flex justify-between items-center">
//                           <span className="text-gray-600">{branch.branchCode}:</span>
//                           <div className="flex items-center gap-1">
//                             <span className="text-xs">{branch.used}/{branch.capacity}</span>
//                             <span className={`px-1 py-0.5 rounded text-xs
//                               ${branch.percentage <= 50 ? 'bg-blue-100 text-blue-700' : ''}
//                               ${branch.percentage > 50 && branch.percentage < 90 ? 'bg-yellow-100 text-yellow-700' : ''}
//                               ${branch.percentage >= 90 ? 'bg-red-100 text-red-700' : ''}
//                             `}>
//                               {branch.percentage.toFixed(0)}%
//                             </span>
//                           </div>
//                         </div>
//                       ))}
//                     </div>
//                   )}

//                   {getCapacityInfo(hoveredDate).branchCapacities.some(b => b.percentage >= 90) && (
//                     <div className="mt-1 pt-1 border-t border-gray-200">
//                       <div className="flex items-center gap-0.5 text-xs text-red-600">
//                         <AlertCircle className="w-3 h-3" />
//                         <span>High capacity</span>
//                       </div>
//                     </div>
//                   )}
//                 </div>
//               </div>
//             )}
//           </div>
//         )}
//       </div>

//       {/* Updated Warning Modal */}
//       {showWarningModal && warningDate && (
//         <div className="fixed inset-0 z-[100] flex items-start justify-center pt-20">
//           <div
//             className="fixed inset-0 bg-black bg-opacity-50"
//             onClick={() => setShowWarningModal(false)}
//           />

//           <div className="relative bg-white rounded-lg shadow-xl p-6 max-w-sm w-full mx-4
//                         animate-slide-down">
//             <div className="flex items-start mb-4">
//               <AlertCircle className="w-6 h-6 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
//               <div>
//                 <h3 className="text-lg font-semibold text-gray-900">
//                   High Capacity Warning
//                 </h3>
//                 <p className="mt-2 text-sm text-gray-600">
//                   The following branches are at high capacity on {format(warningDate, 'dd MMM yyyy')}:
//                 </p>

//                 {/* Show branch-specific warnings */}
//                 <div className="mt-2 space-y-1">
//                   {getCapacityInfo(warningDate).branchCapacities
//                     .filter(b => b.percentage >= 90)
//                     .map(branch => (
//                       <div key={branch.branchCode} className="text-sm">
//                         <span className="font-semibold text-orange-600">
//                           {branch.branchCode}:
//                         </span>{' '}
//                         {branch.percentage.toFixed(0)}% full ({branch.used}/{branch.capacity} slots)
//                       </div>
//                     ))}
//                 </div>

//                 <p className="mt-2 text-sm text-gray-600">
//                   Do you want to continue with this date?
//                 </p>
//               </div>
//             </div>

//             <div className="flex justify-end gap-3 mt-6">
//               <button
//                 type='button'
//                 onClick={() => setShowWarningModal(false)}
//                 className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100
//                          hover:bg-gray-200 rounded-lg transition-colors"
//               >
//                 Cancel
//               </button>
//               <button
//                 type='button'
//                 onClick={confirmHighCapacityDate}
//                 className="px-4 py-2 text-sm font-medium text-white bg-orange-600
//                          hover:bg-orange-700 rounded-lg transition-colors"
//               >
//                 Continue
//               </button>
//             </div>
//           </div>
//         </div>
//       )}

//       {/* Add animation styles */}
//       <style>{`
//         @keyframes slide-down {
//           from {
//             opacity: 0;
//             transform: translateY(-20px);
//           }
//           to {
//             opacity: 1;
//             transform: translateY(0);
//           }
//         }

//         .animate-slide-down {
//           animation: slide-down 0.3s ease-out;
//         }
//       `}</style>

//     </>
//   );
// };

// export default CustomDatePicker;

// components/CustomDatePicker.jsx
import React, { useState, useEffect, useRef } from "react";
import {
  format,
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  isToday,
  addMonths,
  subMonths,
  addYears,
  subYears,
  startOfWeek,
  endOfWeek,
  isSameMonth,
  setYear,
  setMonth,
  getYear,
  getMonth,
} from "date-fns";
import {
  ChevronLeft,
  ChevronRight,
  ChevronsLeft,
  ChevronsRight,
  Calendar,
  AlertCircle,
  ChevronDown,
} from "lucide-react";

const CustomDatePicker = ({
  value,
  onChange,
  allOrders = {},
  branches = [], // Add branches prop
  showCapacityInfo = true,
  placeholder = "dd-mm-yyyy",
  containerClassName = "",
  inputClassName = "",
  calendarClassName = "",
  buttonClassName = "",
  iconClassName = "",
  error = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [hoveredDate, setHoveredDate] = useState(null);
  const [showYearDropdown, setShowYearDropdown] = useState(false);
  const [showMonthDropdown, setShowMonthDropdown] = useState(false);
  const [calendarPosition, setCalendarPosition] = useState({
    top: "auto",
    bottom: "auto",
    left: "auto",
    right: "auto",
    transform: "none",
  });
  const [capacityCardPosition, setCapacityCardPosition] = useState({
    show: false,
    side: "right",
    top: 0,
  });
  const [showWarningModal, setShowWarningModal] = useState(false);
  const [warningDate, setWarningDate] = useState(null);

  const inputRef = useRef(null);
  const calendarRef = useRef(null);
  const yearDropdownRef = useRef(null);
  const monthDropdownRef = useRef(null);

  // Generate years from 1900 to current year
  const currentYear = new Date().getFullYear();
  const years = Array.from(
    { length: currentYear - 1900 + 1 },
    (_, i) => currentYear - i,
  );

  // Month names
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  // Default classes
  const defaultContainerClass = "relative w-full";
  const defaultInputClass = `w-full border rounded-[7px] shadow-sm px-3 py-1.5 cursor-pointer transition-colors flex items-center justify-between ${
    error
      ? "border-red-500"
      : value
        ? "border-blue-700 text-blue-700"
        : "border-gray-300"
  }`;
  const defaultCalendarClass =
    "absolute mt-1 mb-1 bg-white border border-gray-200 rounded-lg shadow-lg z-50 overflow-visible";
  const defaultButtonClass = "relative h-7 text-xs rounded transition-all";
  const defaultIconClass = "w-4 h-4";

  // Get branch capacity
  const getBranchCapacity = (branchCode) => {
    const branch = branches.find((b) => b.branchCode === branchCode);
    return branch?.branchCapacity; // fallback to 10 if not found
  };

  // Close dropdowns when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        yearDropdownRef.current &&
        !yearDropdownRef.current.contains(event.target)
      ) {
        setShowYearDropdown(false);
      }
      if (
        monthDropdownRef.current &&
        !monthDropdownRef.current.contains(event.target)
      ) {
        setShowMonthDropdown(false);
      }
    };

    if (showYearDropdown || showMonthDropdown) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showYearDropdown, showMonthDropdown]);

  // Handle year selection
  const handleYearSelect = (year) => {
    const newDate = setYear(currentMonth, year);
    setCurrentMonth(newDate);
    setShowYearDropdown(false);
  };

  // Handle month selection
  const handleMonthSelect = (monthIndex) => {
    const newDate = setMonth(currentMonth, monthIndex);
    setCurrentMonth(newDate);
    setShowMonthDropdown(false);
  };

  // Calculate calendar position with viewport awareness
  useEffect(() => {
    if (isOpen && inputRef.current && calendarRef.current) {
      const inputRect = inputRef.current.getBoundingClientRect();
      const calendarWidth = 260;
      const calendarHeight = 320;
      const padding = 10;

      const viewport = {
        width: window.innerWidth,
        height: window.innerHeight,
      };

      let position = {
        top: "auto",
        bottom: "auto",
        left: "auto",
        right: "auto",
        transform: "none",
      };

      const spaceBelow = viewport.height - inputRect.bottom - padding;
      const spaceAbove = inputRect.top - padding;

      if (spaceBelow >= calendarHeight) {
        position.top = "100%";
      } else if (spaceAbove >= calendarHeight) {
        position.bottom = "100%";
      } else {
        position.top = "100%";
      }

      const spaceOnRight = viewport.width - inputRect.left - padding;
      const spaceOnLeft = inputRect.right - padding;

      if (spaceOnRight >= calendarWidth) {
        position.left = "0";
      } else if (spaceOnLeft >= calendarWidth) {
        position.right = "0";
      } else {
        const leftOffset =
          (viewport.width - calendarWidth) / 2 - inputRect.left;
        position.left = `${leftOffset}px`;

        if (inputRect.left + leftOffset < padding) {
          position.left = `${padding - inputRect.left}px`;
        } else if (
          inputRect.left + leftOffset + calendarWidth >
          viewport.width - padding
        ) {
          position.left = `${viewport.width - padding - calendarWidth - inputRect.left}px`;
        }
      }

      setCalendarPosition(position);
    }
  }, [isOpen]);

  // Reset hover state when calendar closes
  useEffect(() => {
    if (!isOpen) {
      setHoveredDate(null);
      setCapacityCardPosition({ show: false, side: "right", top: 0 });
      setShowYearDropdown(false);
      setShowMonthDropdown(false);
    }
  }, [isOpen]);

  // Close calendar when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        calendarRef.current &&
        !calendarRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen]);

  // Handle window resize
  useEffect(() => {
    const handleResize = () => {
      if (isOpen) {
        setIsOpen(false);
        setTimeout(() => setIsOpen(true), 0);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [isOpen]);

  // Get capacity info with branch-specific calculations
  const getCapacityInfo = (date) => {
    const dateStr = format(date, "yyyy-MM-dd");
    const orders = allOrders[dateStr] || [];

    // Group orders by branch
    const ordersByBranch = orders.reduce((acc, order) => {
      if (!acc[order.branchCode]) {
        acc[order.branchCode] = [];
      }
      acc[order.branchCode].push(order);
      return acc;
    }, {});

    // Calculate capacity for each branch
    const branchCapacities = Object.entries(ordersByBranch).map(
      ([branchCode, branchOrders]) => {
        const capacity = getBranchCapacity(branchCode);
        const used = branchOrders.length;
        const percentage = (used / capacity) * 100;

        return {
          branchCode,
          capacity,
          used,
          remaining: capacity - used,
          percentage,
        };
      },
    );

    // Calculate overall capacity (for all branches that have orders)
    const activeBranches = Object.keys(ordersByBranch);
    const totalCapacity =
      activeBranches.length > 0
        ? activeBranches.reduce(
            (sum, branchCode) => sum + getBranchCapacity(branchCode),
            0,
          )
        : branches.reduce((sum, branch) => sum + branch.branchCapacity, 0); // Use all branches if no orders

    const totalUsed = orders.length;
    const totalRemaining = totalCapacity - totalUsed;
    const overallPercentage =
      totalCapacity > 0 ? (totalUsed / totalCapacity) * 100 : 0;

    // Find the highest percentage among branches (for color coding)
    const maxBranchPercentage =
      branchCapacities.length > 0
        ? Math.max(...branchCapacities.map((b) => b.percentage))
        : 0;

    return {
      used: totalUsed,
      remaining: totalRemaining,
      percentage: overallPercentage,
      maxBranchPercentage, // Use this for color coding
      orders,
      dateStr,
      branchCapacities,
      totalCapacity,
    };
  };

  // Get color for capacity - now using the highest branch percentage
  const getCapacityColor = (capacityInfo) => {
    const percentage =
      capacityInfo.maxBranchPercentage || capacityInfo.percentage;

    if (percentage === 0) return "text-gray-700";
    if (percentage <= 50) return "text-blue-600 bg-blue-50";
    if (percentage < 90) return "text-yellow-600 bg-yellow-50";
    return "text-red-600 bg-red-50";
  };

  // Handle date hover with mobile-friendly positioning
  const handleDateHover = (date, event) => {
    if (!showCapacityInfo) return;

    const capacityInfo = getCapacityInfo(date);
    if (capacityInfo.used > 0) {
      setHoveredDate(date);

      const buttonRect = event.target.getBoundingClientRect();
      const calendarRect = calendarRef.current?.getBoundingClientRect();

      if (calendarRect) {
        const isMobile = window.innerWidth < 640;
        const cardWidth = 200;
        const cardHeight = 180; // Increased height for branch info

        let side = "right";
        let topPosition = buttonRect.top - calendarRect.top;

        const spaceOnRight = window.innerWidth - calendarRect.right;
        const spaceOnLeft = calendarRect.left;

        if (isMobile) {
          side = "inside";
          topPosition = "auto";
        } else if (spaceOnRight < cardWidth && spaceOnLeft > cardWidth) {
          side = "left";
        }

        if (topPosition + cardHeight > calendarRect.height) {
          topPosition = Math.max(0, topPosition - cardHeight + 30);
        }

        setCapacityCardPosition({
          show: true,
          side,
          top: topPosition,
        });
      }
    }
  };

  // Handle date selection
  const handleDateSelect = (date) => {
    setHoveredDate(null);
    setCapacityCardPosition({ show: false, side: "right", top: 0 });

    if (showCapacityInfo) {
      const capacityInfo = getCapacityInfo(date);

      // Check if any branch is at 90% or more capacity
      const hasHighCapacityBranch = capacityInfo.branchCapacities.some(
        (branch) => branch.percentage >= 90,
      );

      if (hasHighCapacityBranch) {
        setWarningDate(date);
        setShowWarningModal(true);
        return;
      }
    }

    onChange(format(date, "yyyy-MM-dd"));
    setIsOpen(false);
  };

  // Confirm high capacity date selection
  const confirmHighCapacityDate = () => {
    if (warningDate) {
      onChange(format(warningDate, "yyyy-MM-dd"));
      setIsOpen(false);
      setShowWarningModal(false);
      setWarningDate(null);
    }
  };

  // Clear date
  const handleClearDate = () => {
    onChange("");
    setIsOpen(false);
  };

  // Get all days to display
  const getAllDaysInView = () => {
    const start = startOfWeek(startOfMonth(currentMonth));
    const end = endOfWeek(endOfMonth(currentMonth));
    return eachDayOfInterval({ start, end });
  };

  // Navigate year
  const goToPreviousYear = () => setCurrentMonth(subYears(currentMonth, 1));
  const goToNextYear = () => setCurrentMonth(addYears(currentMonth, 1));

  // Navigate month
  const goToPreviousMonth = () => setCurrentMonth(subMonths(currentMonth, 1));
  const goToNextMonth = () => setCurrentMonth(addMonths(currentMonth, 1));

  // Handle input click without focus
  const handleInputClick = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  // Auto-scroll to selected year when dropdown opens
  useEffect(() => {
    if (showYearDropdown && yearDropdownRef.current) {
      const selectedYear = yearDropdownRef.current.querySelector(".bg-blue-50");
      if (selectedYear) {
        selectedYear.scrollIntoView({ block: "center", behavior: "smooth" });
      }
    }
  }, [showYearDropdown]);

  return (
    <>
      <div
        className={`${defaultContainerClass} ${containerClassName}`}
        ref={inputRef}
      >
        {/* Date Input */}
        <div
          onClick={handleInputClick}
          className={`${defaultInputClass} ${inputClassName}`}
        >
          {/* Add truncate and flex-1 here */}
          <span className="truncate flex-1 mr-2">
            {value ? format(new Date(value), "dd-MM-yyyy") : placeholder}
          </span>
          
          {/* Add flex-shrink-0 to the icon so it doesn't get squashed */}
          <Calendar className={`flex-shrink-0 ${defaultIconClass} ${iconClassName}`} />
        </div>

        {/* Calendar Dropdown */}
        {isOpen && (
          <div
            ref={calendarRef}
            className={`${defaultCalendarClass} ${calendarClassName}`}
            style={{
              ...calendarPosition,
              width: "260px",
              maxWidth: "calc(100vw - 20px)",
            }}
          >
            {/* Enhanced Navigation with Year and Month Selection */}
            <div className="p-2 border-b border-gray-200">
              <div className="flex items-center justify-between">
                <button
                  onClick={goToPreviousYear}
                  className="p-0.5 hover:bg-gray-100 rounded transition-colors"
                  title="Previous year"
                  type="button"
                >
                  <ChevronsLeft className="w-3.5 h-3.5" />
                </button>

                <button
                  onClick={goToPreviousMonth}
                  className="p-0.5 hover:bg-gray-100 rounded transition-colors"
                  title="Previous month"
                  type="button"
                >
                  <ChevronLeft className="w-3.5 h-3.5" />
                </button>

                <div className="flex items-center gap-1">
                  {/* Month Dropdown */}
                  <div className="relative" ref={monthDropdownRef}>
                    <button
                      type="button"
                      onClick={() => {
                        setShowMonthDropdown(!showMonthDropdown);
                        setShowYearDropdown(false);
                      }}
                      className="flex items-center gap-1 px-2 py-1 text-xs font-semibold hover:bg-gray-100 rounded transition-colors"
                    >
                      {format(currentMonth, "MMM")}
                      <ChevronDown className="w-3 h-3" />
                    </button>

                    {showMonthDropdown && (
                      <div className="absolute top-full left-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-[70] w-32">
                        <div className="max-h-48 overflow-y-auto">
                          {monthNames.map((month, index) => (
                            <button
                              key={month}
                              type="button"
                              onClick={() => handleMonthSelect(index)}
                              className={`block w-full text-left px-3 py-1.5 text-xs hover:bg-gray-100 transition-colors
                                ${getMonth(currentMonth) === index ? "bg-blue-50 text-blue-600 font-semibold" : ""}
                              `}
                            >
                              {month}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Year Dropdown */}
                  <div className="relative" ref={yearDropdownRef}>
                    <button
                      type="button"
                      onClick={() => {
                        setShowYearDropdown(!showYearDropdown);
                        setShowMonthDropdown(false);
                      }}
                      className="flex items-center gap-1 px-2 py-1 text-xs font-semibold hover:bg-gray-100 rounded transition-colors"
                    >
                      {format(currentMonth, "yyyy")}
                      <ChevronDown className="w-3 h-3" />
                    </button>

                    {showYearDropdown && (
                      <div className="absolute top-full right-0 mt-1 bg-white border border-gray-200 rounded-md shadow-lg z-[70] w-20">
                        <div className="max-h-48 overflow-y-auto">
                          {years.map((year) => (
                            <button
                              key={year}
                              type="button"
                              onClick={() => handleYearSelect(year)}
                              className={`block w-full text-center px-3 py-1.5 text-xs hover:bg-gray-100 transition-colors
                                ${getYear(currentMonth) === year ? "bg-blue-50 text-blue-600 font-semibold" : ""}
                              `}
                            >
                              {year}
                            </button>
                          ))}
                        </div>
                      </div>
                    )}
                  </div>
                </div>

                <button
                  onClick={goToNextMonth}
                  className="p-0.5 hover:bg-gray-100 rounded transition-colors"
                  title="Next month"
                  type="button"
                >
                  <ChevronRight className="w-3.5 h-3.5" />
                </button>

                <button
                  onClick={goToNextYear}
                  className="p-0.5 hover:bg-gray-100 rounded transition-colors"
                  title="Next year"
                  type="button"
                >
                  <ChevronsRight className="w-3.5 h-3.5" />
                </button>
              </div>
            </div>

            {/* Compact Calendar Grid */}
            <div className="p-2">
              {/* Weekday headers */}
              <div className="grid grid-cols-7 gap-0.5 mb-0.5">
                {["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"].map((day) => (
                  <div
                    key={day}
                    className="text-center text-xs text-gray-500 font-medium py-0.5"
                  >
                    {day}
                  </div>
                ))}
              </div>

              {/* Days Grid */}
              <div className="grid grid-cols-7 gap-0.5">
                {getAllDaysInView().map((date, index) => {
                  const isCurrentMonth = isSameMonth(date, currentMonth);
                  const capacityInfo = getCapacityInfo(date);
                  const isSelected =
                    value && format(date, "yyyy-MM-dd") === value;
                  const colorClass = getCapacityColor(capacityInfo);

                  const dateButtonClass = `
                    ${defaultButtonClass} ${buttonClassName}
                    ${!isCurrentMonth ? "text-gray-400" : "text-gray-700"}
                    ${isSelected ? "bg-blue-600 text-white hover:bg-blue-700" : "hover:bg-gray-100"}
                    ${isToday(date) && !isSelected ? "font-bold ring-1 ring-blue-400" : ""}
                    ${!isSelected && isCurrentMonth && capacityInfo.used > 0 && showCapacityInfo ? colorClass : ""}
                  `.trim();

                  return (
                    <button
                      type="button"
                      key={index}
                      onClick={() => handleDateSelect(date)}
                      onMouseEnter={(e) => handleDateHover(date, e)}
                      onMouseLeave={() => {
                        setHoveredDate(null);
                        setCapacityCardPosition({
                          ...capacityCardPosition,
                          show: false,
                        });
                      }}
                      className={dateButtonClass}
                    >
                      <span>{format(date, "d")}</span>
                      {showCapacityInfo &&
                        capacityInfo.used > 0 &&
                        !isSelected && (
                          <div
                            className={`absolute bottom-0.5 left-1/2 -translate-x-1/2 w-1 h-1 rounded-full
                          ${capacityInfo.maxBranchPercentage <= 50 ? "bg-blue-500" : ""}
                          ${capacityInfo.maxBranchPercentage > 50 && capacityInfo.maxBranchPercentage < 90 ? "bg-yellow-500" : ""}
                          ${capacityInfo.maxBranchPercentage >= 90 ? "bg-red-500" : ""}
                        `}
                          />
                        )}
                    </button>
                  );
                })}
              </div>

              {/* Clear and Today buttons */}
              <div className="mt-2 pt-2 border-t border-gray-200 flex justify-between">
                <button
                  type="button"
                  onClick={handleClearDate}
                  className="text-xs text-gray-600 hover:text-gray-700 font-medium 
                           py-0.5 px-2 hover:bg-gray-50 rounded transition-colors"
                >
                  Clear
                </button>
                <button
                  type="button"
                  onClick={() => {
                    const today = new Date();
                    setCurrentMonth(today);
                    handleDateSelect(today);
                  }}
                  className="text-xs text-blue-600 hover:text-blue-700 font-medium 
                           py-0.5 px-2 hover:bg-blue-50 rounded transition-colors"
                >
                  Today
                </button>
              </div>
            </div>

            {/* Enhanced Capacity Info Card */}
            {showCapacityInfo && hoveredDate && capacityCardPosition.show && (
              <div
                className={`
                  ${
                    capacityCardPosition.side === "inside"
                      ? "absolute bottom-0 left-0 right-0 border-t"
                      : `absolute ${capacityCardPosition.side === "right" ? "left-full ml-1" : "right-full mr-1"}`
                  }
                  bg-white border border-gray-200 rounded-md shadow-lg p-2 z-[60] min-w-[180px]
                `}
                style={
                  capacityCardPosition.side !== "inside"
                    ? { top: `${capacityCardPosition.top}px` }
                    : {}
                }
              >
                <div className="text-xs">
                  <div className="font-semibold text-gray-800 mb-1">
                    {format(hoveredDate, "dd MMM yyyy")}
                  </div>

                  {/* Overall capacity */}
                  <div className="space-y-0.5 pb-1 mb-1 border-b border-gray-200">
                    <div className="flex justify-between">
                      <span className="text-gray-600">Total Orders:</span>
                      <span className="font-medium">
                        {getCapacityInfo(hoveredDate).used}
                      </span>
                    </div>
                  </div>

                  {/* Branch-wise capacity */}
                  {getCapacityInfo(hoveredDate).branchCapacities.length > 0 && (
                    <div className="space-y-1">
                      <div className="text-xs font-medium text-gray-700">
                        By Branch:
                      </div>
                      {getCapacityInfo(hoveredDate).branchCapacities.map(
                        (branch) => (
                          <div
                            key={branch.branchCode}
                            className="flex justify-between items-center"
                          >
                            <span className="text-gray-600">
                              {branch.branchCode}:
                            </span>
                            <div className="flex items-center gap-1">
                              <span className="text-xs">
                                {branch.used}/{branch.capacity}
                              </span>
                              <span
                                className={`px-1 py-0.5 rounded text-xs
                              ${branch.percentage <= 50 ? "bg-blue-100 text-blue-700" : ""}
                              ${branch.percentage > 50 && branch.percentage < 90 ? "bg-yellow-100 text-yellow-700" : ""}
                              ${branch.percentage >= 90 ? "bg-red-100 text-red-700" : ""}
                            `}
                              >
                                {branch.percentage.toFixed(0)}%
                              </span>
                            </div>
                          </div>
                        ),
                      )}
                    </div>
                  )}

                  {getCapacityInfo(hoveredDate).branchCapacities.some(
                    (b) => b.percentage >= 90,
                  ) && (
                    <div className="mt-1 pt-1 border-t border-gray-200">
                      <div className="flex items-center gap-0.5 text-xs text-red-600">
                        <AlertCircle className="w-3 h-3" />
                        <span>High capacity</span>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            )}
          </div>
        )}
      </div>

      {/* Updated Warning Modal */}
      {showWarningModal && warningDate && (
        <div className="fixed inset-0 z-[100] flex items-start justify-center pt-20">
          <div
            className="fixed inset-0 bg-black bg-opacity-50"
            onClick={() => setShowWarningModal(false)}
          />

          <div
            className="relative bg-white rounded-lg shadow-xl p-6 max-w-sm w-full mx-4 
                        animate-slide-down"
          >
            <div className="flex items-start mb-4">
              <AlertCircle className="w-6 h-6 text-orange-500 mr-3 flex-shrink-0 mt-0.5" />
              <div>
                <h3 className="text-lg font-semibold text-gray-900">
                  High Capacity Warning
                </h3>
                <p className="mt-2 text-sm text-gray-600">
                  The following branches are at high capacity on{" "}
                  {format(warningDate, "dd MMM yyyy")}:
                </p>

                {/* Show branch-specific warnings */}
                <div className="mt-2 space-y-1">
                  {getCapacityInfo(warningDate)
                    .branchCapacities.filter((b) => b.percentage >= 90)
                    .map((branch) => (
                      <div key={branch.branchCode} className="text-sm">
                        <span className="font-semibold text-orange-600">
                          {branch.branchCode}:
                        </span>{" "}
                        {branch.percentage.toFixed(0)}% full ({branch.used}/
                        {branch.capacity} slots)
                      </div>
                    ))}
                </div>

                <p className="mt-2 text-sm text-gray-600">
                  Do you want to continue with this date?
                </p>
              </div>
            </div>

            <div className="flex justify-end gap-3 mt-6">
              <button
                type="button"
                onClick={() => setShowWarningModal(false)}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 
                         hover:bg-gray-200 rounded-lg transition-colors"
              >
                Cancel
              </button>
              <button
                type="button"
                onClick={confirmHighCapacityDate}
                className="px-4 py-2 text-sm font-medium text-white bg-orange-600 
                         hover:bg-orange-700 rounded-lg transition-colors"
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add animation styles */}
      <style>{`
        @keyframes slide-down {
          from {
            opacity: 0;
            transform: translateY(-20px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }
        
        .animate-slide-down {
          animation: slide-down 0.3s ease-out;
        }
      `}</style>
    </>
  );
};

export default CustomDatePicker;
